// extracted by mini-css-extract-plugin
export var copyIcon = "_yf-2";
export var discountCard = "_yf-0";
export var discountCode = "_yf-3";
export var discountContent = "_yf-1";
export var loadingCard = "_yf-4";